export function createBackendErrorHandler(...catalogues) {
    const messages = Object.assign({}, ...catalogues.map(catalogue => catalogue.messages))
    const dialogs = Object.assign({}, ...catalogues.map(catalogue => catalogue.dialogs))
    function getBackendErrorDialog(code) {
        if (typeof code !== 'string') return null
        if (Object.prototype.hasOwnProperty.call(dialogs, code)) {
            const dialog = dialogs[code]
            return {
                ...dialog,
                dialogAction: dialog.dialogAction.map(action => (action === 'close' ? 'dismiss' : action)),
                ...(dialog.primaryAction ? { primaryAction: [...dialog.primaryAction] } : {})
            }
        }
        if (!Object.prototype.hasOwnProperty.call(messages, code)) return null
        return { dialogTitle: 'Action could not be completed', dialogText: messages[code], dialogAction: ['dismiss'] }
    }
    function getBackendErrorMessage(error, fallback = 'The operation could not be completed. Please try again or contact support.') {
        if (error?.customErrorHandled) return ''
        const code = error?.response?.data?.code
        if (Array.isArray(error?.config?.expectedErrorCodes) && error.config.expectedErrorCodes.includes(code)) return ''
        return getBackendErrorDialog(code)?.dialogText || fallback
    }
    return { getBackendErrorMessage, getBackendErrorDialog }
}
